import { companyHistories } from '@/configs/translates.config'
export default {
	'add-new-company-history': `add new ${companyHistories.en.singular}`,
	'the-company-history': `the ${companyHistories.en.singular}`,
	'company-history': companyHistories.en.singular,
}